import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ButtonAction extends BaseOption {
  static userInterfaceComponent = {
    label: "On Click",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: [
        {
          name: "Go To Url",
          id: "goToUrl",
        },
        {
          name: "Open Modal",
          id: "openModal",
        },
        {
          name: "Back to Previous Page",
          id: "goBack",
        },
      ],
    },
  };

  static defaultValue = "goToUrl";
}
